<script lang="ts">
	//UI
	import { Selectabled } from "@hitit/new_ui";
	//Utils
	import { selectableList } from "../../v7/component/atu/TimeSelection.svelte";
	//Types
	//Props
	export let time: string;
	//Constants
	const text = selectableList.find((v) => v.case === time)?.text || "Error";
	//Variables
	$: lockStatus = time === "REJECT";
	$: lockStatusImage = lockStatus
		? "/img/icons/Locked.png"
		: "/img/icons/Unlocked.png";
	//Functions
	//Do

</script>

<div class="body">
	<div class="circle">
		<img class:lock={lockStatus} src={lockStatusImage} alt={time} />
	</div>
	<div class="texts">
		<div class="main">
			<span class="icon">
				<Selectabled fill="#6d6f76" />
			</span>
			{text}
		</div>
		<div class="message">선택한 응답이 전송되었습니다</div>
	</div>
</div>

<style lang="scss">
	.body {
		display: flex;
		flex-direction: column;
		padding-top: 95px;
		width: 100%;
		align-items: center;
		gap: 40px;
		.circle {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 210px;
			height: 210px;
			background-color: white;
			border-radius: 100%;

			img {
				width: 109.8px;
				height: 119.2px;
				object-fit: contain;
				&.lock {
					width: 81.8px;
					height: 119.2px;
				}
			}
		}
		.texts {
			display: flex;
			flex-direction: column;
			text-align: center;
			gap: 20px;
			color: #46474b;
			.main {
				display: flex;
				gap: 7px;
				font-size: 1.25rem;
				font-weight: 500;
				justify-content: center;
				.icon {
					width: 20px;
					height: 20px;
				}
			}
		}
	}

</style>
